import UserRequest from "@/domain/entities/vistassistant/UserRequest";

const userRequestMapper = (content: string): UserRequest =>
    new UserRequest({
        content,
    });

export default userRequestMapper;
